// src/lib/layouts/buildDefaults.ts
import type { LayoutDefaultsContext, PostLayoutConfig, PostLayoutKind } from './types';
import { cortesConfigForPreset } from './cortesPresets';
import { circuloConfigForPreset } from './resolveCirculoPreset';

export function buildDefaults(
  kind: PostLayoutKind,
  ctx: LayoutDefaultsContext,
): PostLayoutConfig {
  switch (kind) {
    case 'model_x':
      return {
        kind: 'model_x',
        displayName: ctx.channelName || 'The Clippers',
        handle: '@autoclipper.live',
        postText: ctx.clipTitle ?? '',
        avatarUrl: ctx.channelAvatarUrl,
      };
    case 'choquei':
      return {
        kind: 'choquei',
        brandName: 'CHOQUEI',
        headline: ctx.clipTitle ?? '',
        accentColor: '#ED1C24',
        logoUrl: undefined,
        avatarUrl: undefined,
        imageUrl: undefined,
      };
    case 'breaking_news':
      return {
        kind: 'breaking_news',
        channelName: 'BREAKING NEWS',
        tag: 'URGENTE',
        headline: ctx.clipTitle ?? '',
        accentColor: '#ED1C24',
        logoUrl: undefined,
        imageUrl: undefined,
      };
    case 'newspaper':
      return {
        kind: 'newspaper',
        sourceName: 'NEWS',
        headline: ctx.clipTitle ?? '',
        kicker: '',
        accentColor: '#111111',
        imageUrl: undefined,
      };
    case 'instagram':
      return {
        kind: 'instagram',
        handle: '@autoclipper.live',
        caption: ctx.clipTitle ?? '',
        likes: '12.4k',
        avatarUrl: undefined,
        imageUrl: undefined,
      };
    case 'fact_quote':
      return {
        kind: 'fact_quote',
        headline: ctx.clipTitle ?? '',
        textColor: '#ffffff',
        scrimColor: 'rgba(0,0,0,0.55)',
        imageUrl: undefined,
      };
    case 'satisfatorio':
      return {
        kind: 'satisfatorio',
        fillerUrl: '',
        clipPosition: 'top',
        clipRatio: 50,
        title: ctx.clipTitle ?? '',
        titleFrame: 'pill',
        titleAccentColor: '#ED1C24',
        fillerSpeed: 1,
      };
    case 'news_post':
      return {
        kind: 'news_post',
        style: 'choquei',
        brandName: 'CHOQUEI',
        headline: ctx.clipTitle ?? '',
        accentColor: '#ED1C24',
        logoUrl: undefined,
        avatarUrl: undefined,
        imageUrl: undefined,
        tag: 'URGENTE',
        kicker: '',
        likes: '12.4k',
      };
    case 'cortes':
      return cortesConfigForPreset('caixa-vermelha');
    case 'circulo':
      return circuloConfigForPreset('baixo');
    case 'fofoca':
      return {
        kind: 'fofoca',
        profileName: 'Seu perfil',
        caption: ctx.clipTitle ?? '',
        avatarUrl: undefined,
        imageUrl: undefined,
        storyMedia: 'image',
        fillerSpeed: 1,
        badgeUrl: undefined,
        badgeBorderRadius: 50,
        videoTitle: '',
        videoTitleFontFamily: 'Montserrat ExtraBold',
        videoTitleFontUrl: undefined,
        videoTitleFontSize: 49,
        handle: '',
        accentColor: '#ffe600',
        clipPosition: 'right',
      };
    case 'triple_split':
      return {
        kind: 'triple_split',
        fillerUrl: '',
        bottomFillerUrl: '',
        title: ctx.clipTitle ?? '',
        title2: '',
        titleFrame: 'pill',
        titleAccentColor: '#ED1C24',
        fillerSpeed: 1,
      };
    default:
      // reserved kinds (tiktok) are not implemented yet
      throw new Error(`buildDefaults: unimplemented layout kind: ${kind}`);
  }
}
